var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisualize = function SvgVisualize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.689,
    height: 59.772
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 555",
    fill: "#376996"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 235",
    d: "M47.907 4.512h-7.3l1.8-1.8A1.59 1.59 0 0 0 40.159.466l-4.5 4.509a1.569 1.569 0 0 0-.463 1.124 1.626 1.626 0 0 0 .463 1.124l4.509 4.509a1.592 1.592 0 0 0 1.124.463 1.615 1.615 0 0 0 1.124-.463 1.588 1.588 0 0 0 0-2.248l-1.8-1.8h7.3a8.6 8.6 0 0 1 8.6 8.6v5.326a1.587 1.587 0 1 0 3.173 0v-5.329A11.789 11.789 0 0 0 47.907 4.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 236",
    d: "M57.984 30.536H31.922a1.591 1.591 0 0 0-1.587 1.587v26.063a1.591 1.591 0 0 0 1.587 1.587h26.063a1.591 1.591 0 0 0 1.587-1.587V32.123a1.583 1.583 0 0 0-1.588-1.587Zm-1.587 26.063H33.508V33.711h22.889V56.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "M19.517 48.043a1.59 1.59 0 0 0-2.248 2.248l1.8 1.8h-7.3a8.6 8.6 0 0 1-8.6-8.6v-5.329a1.587 1.587 0 0 0-3.174 0v5.329A11.778 11.778 0 0 0 11.764 55.26h7.3l-1.8 1.8a1.587 1.587 0 0 0 1.124 2.711 1.615 1.615 0 0 0 1.124-.463l4.509-4.509a1.588 1.588 0 0 0 0-2.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 238",
    d: "M1.707 3.178A1.58 1.58 0 0 0 3.293 1.59 1.626 1.626 0 0 0 2.83.466 1.587 1.587 0 0 0 .119 1.59a1.6 1.6 0 0 0 .463 1.124 1.626 1.626 0 0 0 1.125.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 239",
    d: "M14.745 3.178a1.587 1.587 0 1 0-1.587-1.587 1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 240",
    d: "M8.226 3.178a1.587 1.587 0 1 0-1.587-1.587 1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M21.251 3.178a1.587 1.587 0 1 0-1.587-1.587 1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M27.77.003a1.626 1.626 0 0 0-1.124.463 1.6 1.6 0 0 0 0 2.248 1.587 1.587 0 0 0 2.711-1.124A1.58 1.58 0 0 0 27.77.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 243",
    d: "M27.77 19.56a1.587 1.587 0 1 0 1.587 1.587 1.575 1.575 0 0 0-1.587-1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 244",
    d: "M27.77 13.041a1.587 1.587 0 1 0 1.587 1.587 1.575 1.575 0 0 0-1.587-1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 245",
    d: "M27.77 6.522a1.587 1.587 0 1 0 1.587 1.587 1.591 1.591 0 0 0-1.587-1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 246",
    d: "M27.77 26.066a1.58 1.58 0 0 0-1.587 1.587 1.626 1.626 0 0 0 .463 1.124 1.59 1.59 0 1 0 1.124-2.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M21.251 29.241a1.587 1.587 0 1 0-1.587-1.587 1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 248",
    d: "M14.745 29.241a1.587 1.587 0 1 0-1.587-1.587 1.575 1.575 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 249",
    d: "M8.226 29.241a1.587 1.587 0 1 0-1.587-1.587 1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 250",
    d: "M1.707 29.241A1.59 1.59 0 1 0 .12 27.654a1.58 1.58 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 251",
    d: "M1.707 22.735A1.587 1.587 0 1 0 .12 21.148a1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 252",
    d: "M1.707 16.216A1.587 1.587 0 1 0 .12 14.629a1.591 1.591 0 0 0 1.587 1.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 253",
    d: "M1.707 9.697A1.587 1.587 0 1 0 .12 8.11a1.591 1.591 0 0 0 1.587 1.587Z"
  }))));
};
export default SvgVisualize;